import React from "react";
import PropTypes from "prop-types";
import { TextField, FormGroup, MenuItem, Grid } from "@material-ui/core";

import { COUNTRIES } from "../../../../const";

const KidInformations = props => {
  const { values, handleChange, handleBlur, errors, touched, style } = props;

  return (
    <div>
      <h5>Kid's Informations</h5>
      <Grid container spacing={24}>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label="Nom *"
              name="nom"
              variant="outlined"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span className={style.formError}>
                  {touched.nom && errors.nom}
                </span>
              }
              value={values.nom}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label="Prénom *"
              name="prenom"
              variant="outlined"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span className={style.formError}>
                  {touched.prenom && errors.prenom}
                </span>
              }
              value={values.prenom}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label="Date de naissance *"
              name="dateNaissance"
              variant="outlined"
              type="date"
              format={"DD/MM/YYYY"}
              InputLabelProps={{
                shrink: true
              }}
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span className={style.formError}>
                  {touched.dateNaissance && errors.dateNaissance}
                </span>
              }
              value={values.dateNaissance}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label="Date d'admission' *"
              name="dateAdmission"
              variant="outlined"
              type="date"
              format={"DD/MM/YYYY"}
              InputLabelProps={{
                shrink: true
              }}
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span className={style.formError}>
                  {touched.dateAdmission && errors.dateAdmission}
                </span>
              }
              value={values.dateAdmission}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={8}>
          <FormGroup>
            <TextField
              label="Rue *"
              name="adresseDto['rue']"
              variant="outlined"
              type="text"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span className={style.formError}>
                  {touched.adresseDto &&
                    touched.adresseDto["rue"] &&
                    errors.adresseDto &&
                    errors.adresseDto["rue"]}
                </span>
              }
              value={values.adresseDto["rue"]}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={4}>
          <FormGroup>
            <TextField
              label="Ville *"
              name="adresseDto['ville']"
              variant="outlined"
              type="text"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span className={style.formError}>
                  {touched.adresseDto &&
                    touched.adresseDto["ville"] &&
                    errors.adresseDto &&
                    errors.adresseDto["ville"]}
                </span>
              }
              value={values.adresseDto["ville"]}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label="Code Postale *"
              name="adresseDto['codePostale']"
              variant="outlined"
              type="number"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span className={style.formError}>
                  {touched.adresseDto &&
                    touched.adresseDto["codePostale"] &&
                    errors.adresseDto &&
                    errors.adresseDto["codePostale"]}
                </span>
              }
              value={values.adresseDto["codePostale"]}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              select
              label="Pays "
              name="adresseDto['pays']"
              variant="outlined"
              type="text"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span className={style.formError}>
                  {touched.adresseDto &&
                    touched.adresseDto["pays"] &&
                    errors.adresseDto &&
                    errors.adresseDto["pays"]}
                </span>
              }
              value={values.adresseDto["pays"]}
            >
              {COUNTRIES.map(country => (
                <MenuItem key={country} value={country}>
                  {country}
                </MenuItem>
              ))}
            </TextField>
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label="Poid *"
              name="poid"
              variant="outlined"
              type="number"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span className={style.formError}>
                  {touched.poid && errors.poid}
                </span>
              }
              value={values.poid}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label="Taille *"
              name="taille"
              variant="outlined"
              type="number"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span className={style.formError}>
                  {touched.taille && errors.taille}
                </span>
              }
              value={values.taille}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              select
              label="Sexe "
              name="sexe"
              variant="outlined"
              type="text"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span className={style.formError}>
                  {touched.sexe && errors.sexe}
                </span>
              }
              value={values.sexe}
            >
              <MenuItem key="M" value="Masculin">
                Masculin
              </MenuItem>
              <MenuItem key="F" value="Feminin">
                Feminin
              </MenuItem>
            </TextField>
          </FormGroup>
        </Grid>
      </Grid>
    </div>
  );
};

KidInformations.propTypes = {
  values: PropTypes.object,
  errors: PropTypes.object,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  handleDisplayCamera: PropTypes.func,
  displayCamera: PropTypes.bool,
  touched: PropTypes.object,
  style: PropTypes.object
};

export default KidInformations;
